exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Circle-module__circle___1oGmD{cursor:pointer;background-color:#fff;border-radius:999px;height:40px;width:40px;display:flex;justify-content:center;align-items:center;font-size:18px}", ""]);

// exports
exports.locals = {
	"circle": "Circle-module__circle___1oGmD"
};